import Home from '@/views/users/Home'

export default {
  path: '/redaktorer/:id?',
  name: 'RedaktorerHome',
  props: true,
  component: Home,
}
